'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('SubModuleDialogCtrl', SubModuleDialogCtrl);

  SubModuleDialogCtrl.$inject = ['$scope', '$mdDialog', 'Module', 'Project', 'errorMessageService', '$log',
    '$document', 'ProjectBusinessService', 'Labels', '$state'];

  function SubModuleDialogCtrl ($scope, $mdDialog, Module, ProjectAPI, errorMessageService, $log,
    $document, ProjectBusinessService, Labels, $state) {

    // Used to determine if we allow changing the protected value
    $scope.currentState = $state.current.name;

    $scope.dialogCtrl = function (dialogScope, mdDialog) {
      dialogScope.cancel = function () {
        mdDialog.cancel();
      };

      dialogScope.createOrUpdate = function () {
        let resource;
        if (dialogScope.action === 'CREATE') {
          resource = dialogScope.create();
        } else {
          resource = dialogScope.update();
        }

        resource.$promise.then(function (data) {
          mdDialog.hide();
          errorMessageService.showSuccess('Submodule succesvol aangemaakt of bewerkt');
          dialogScope.callback(data, true);
        }).catch(function (err) {
          $log.error('error while creating or editing a module', err);
        });
      };

      dialogScope.create = function () {
        if (dialogScope.project) {
          const data = {
            _id: dialogScope.project._id,
            paramId: dialogScope.originalModule._id,
            versionId: dialogScope.project.versionId,
            submodule: {
              name: dialogScope.module.name
            }
          };
          return ProjectAPI.createSubModule(data);
        }
        return Module.createSubmodule({
          id: dialogScope.originalModule._id
        },
        {
          submodule: {
            name: dialogScope.module.name
          }
        });
      };

      dialogScope.update = function () {
        if (dialogScope.project) {
          const module = ProjectBusinessService.findModuleBySubmoduleId(dialogScope.project,
            dialogScope.originalModule._id);

          const data = {
            _id: dialogScope.project._id,
            paramId: module._id,
            secondParamId: dialogScope.originalModule._id,
            versionId: dialogScope.project.versionId,
            submodule: {
              name: dialogScope.module.name,
              protected: dialogScope.module.protected
            }
          };
          return ProjectAPI.updateSubModule(data);
        }
        return Module.updateSubmodule({
          submoduleId: dialogScope.originalModule._id
        },
        {
          submodule: {
            name: dialogScope.module.name,
            protected: dialogScope.module.protected
          }
        });
      };
    };

    $scope.LABELS = Labels;

    $scope.dialogCtrl.$inject = ['$scope', '$mdDialog'];

    $scope.open = function (ev, callback, module, project) {

      let enhancedModule;
      if (module) {
        $scope.originalModule = module;
      }

      if (module.submodules) {
        $scope.action = 'CREATE';
        enhancedModule = {
          name: '',
          protected: false
        };
      } else {
        $scope.action = 'EDIT';
        enhancedModule = {
          name: module.name,
          protected: module.protected
        };
      }

      $scope.module = enhancedModule;
      $scope.callback = callback;
      $scope.project = project;

      $mdDialog.show({
        controller: $scope.dialogCtrl,
        templateUrl: 'app-legacy/module/submodule-dialog/submodule_dialog.tmpl.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        scope: $scope.$new()
      })
        .then(function () {
          // called on .hide()
        }, function () {
          // called on .close();
        });
    };
  }

})();
